// import uuidv4 from 'uuid/v4'

// export const uuid = () => uuidv4().split('-')[0];

export const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));